module.exports = __webpack_public_path__ + "static/mongo-ffb03c9e1a540c13fbb885d6b8c3121d.png";